export default {"src":"/_next/static/media/holy-see.949deed6.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};